/**
 * ImageWrapper component using styled from @compiled/react
 */
import type { StyledProps } from '@compiled/react';
import { styled } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import type { ComponentType, ClassAttributes, ImgHTMLAttributes } from 'react';

const COVER_IMAGE_FIXED_HEIGHT = 147;
const COVER_IMAGE_WIDTH_TO_HEIGHT_RATIO = 38 / 7;
const CALCULATE_SCALED_COVER_IMAGE_HEIGHT_FOR_EDIT_PAGE = `round(down, calc(100cqw / (${COVER_IMAGE_WIDTH_TO_HEIGHT_RATIO})), 1px)`;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- To migrate as part of go/ui-styling-standard
export const StyledImageWrapper: ComponentType<
	{
		coverPicturePosition?: number | null;
		isFixedWidthImageOption?: boolean;
		smartSpaceOverviewHeight?: number;
		isRoundedCorners?: boolean;
	} & ClassAttributes<HTMLImageElement> &
		ImgHTMLAttributes<HTMLImageElement> &
		StyledProps
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
> = styled.img<{
	coverPicturePosition?: number | null;
	isFixedWidthImageOption?: boolean;
	smartSpaceOverviewHeight?: number;
	isRoundedCorners?: boolean;
}>({
	width: '100%',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	height: ({ isFixedWidthImageOption, smartSpaceOverviewHeight }) =>
		smartSpaceOverviewHeight
			? `${smartSpaceOverviewHeight}px`
			: isFixedWidthImageOption
				? `${COVER_IMAGE_FIXED_HEIGHT}px`
				: CALCULATE_SCALED_COVER_IMAGE_HEIGHT_FOR_EDIT_PAGE,
	objectFit: 'cover',
	position: 'absolute',
	'&:hover': {
		opacity: 1,
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	borderRadius: ({ isRoundedCorners }) => (isRoundedCorners ? token('radius.xlarge') : 'unset'),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	objectPosition: ({ coverPicturePosition }) => `center ${coverPicturePosition}%`,
	aspectRatio: '38 / 7',
});
